// import React from 'react';
// import { createRoot } from 'react-dom/client'; // Import createRoot from react-dom/client
// import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
// import configureStore from '../shared/configureStore';
// import App from '../shared/App';
// import { HelmetProvider } from 'react-helmet-async';

// if(process.env.NODE_ENV == 'production'){
//   console.log = () => {}
// }

// // Configure Redux store
// const store = configureStore(window.__initialData__);
// const container = document.getElementById('root');

// // Create a root for concurrent mode
// const root = createRoot(container);

// if (typeof window !== 'undefined' && container) {
//   root.render(
//     <HelmetProvider>
//       <Provider store={store}>
//         <BrowserRouter>
//           <App location={window.location.href} />
//         </BrowserRouter>
//       </Provider>
//     </HelmetProvider>
//   );
// }
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from '../shared/configureStore';
import App from '../shared/App';
import { HelmetProvider } from 'react-helmet-async';
import { logoutUser } from "../shared/store/actions/headerActions"
import Cookies from "js-cookie";

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
}

/**
 * ✅ Hydrate Redux from SERVER
 */
const preloadedState = window.__INITIAL_REDUX_STATE__ || {};
const store = configureStore(preloadedState);

const container = document.getElementById('root');
const root = createRoot(container);

// Must run before any component mounts: child components mount (and fire
// componentDidMount) before App's componentDidMount, so setting these there
// is too late for anything that calls Service.postServiceCall on mount.
global.userAgent = navigator.userAgent;
global.isdesktop = !/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);

let authData = window.__AUTH_DATA__?.authData
//set global userAry for analytics purpose ---jan 30
if (window.__AUTH_DATA__) {
  console.log("🌐 Setting global userAry from __AUTH_DATA__", window.__AUTH_DATA__);
  global.userAry = window.__AUTH_DATA__?.authData;
  authData = window.__AUTH_DATA__?.authData || {};
  global.ftk = window.__AUTH_DATA__?.authData?.ftk
  global.accessToken = window.__AUTH_DATA__?.authData?.token?.["access-token"] || "";
  global.uID = window.__AUTH_DATA__?.authData?.uId || "";
  global.clientId = window.__AUTH_DATA__?.authData?.clientId || "";
  global.currentURL = window.location.href
}

// 🔎 [childData debug] trap any later reassignment of authData.childData / global.userAry.childData
// to catch exactly which script (likely the remote header bundle) overwrites it, with a stack trace.
if (typeof window !== 'undefined' && authData && typeof authData === 'object') {
  console.log("🔎 [childData debug] snapshot at browser/index.js top:", JSON.stringify(authData.childData));
  let _trappedChildData = authData.childData;
  try {
    Object.defineProperty(authData, 'childData', {
      configurable: true,
      enumerable: true,
      get() {
        return _trappedChildData;
      },
      set(v) {
        console.trace("🚨 [childData debug] authData.childData REASSIGNED to:", JSON.stringify(v));
        _trappedChildData = v;
      }
    });
  } catch (e) {
    console.log("🔎 [childData debug] failed to trap authData.childData:", e);
  }
}

if (authData) {
  console.log("inside authdata", authData)
  if (authData["clientId"]) {
    global.clientId = authData["clientId"];
  }
  if (authData["uId"]) {
    global.uID = authData["uId"];
  }
  if (authData["token"]["access-token"]) {
    global.accessToken = authData["token"]["access-token"];
  }
  if (authData["token"]["mycid"]) {
    global.userAry["mycid"] = authData["token"]["mycid"];
  }
  if (authData["childData"]) {
    global.userAry["childData"] = authData["childData"];
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["userPhoto"]
    ) {
      global.userAry["userPhoto"] =
        authData["childData"]["UserMaster"]["userPhoto"];
    }
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["firstname"]
    ) {
      global.userAry["userName"] =
        authData["childData"]["UserMaster"]["firstname"];
    }
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["Sex"]
    ) {
      global.userAry["Sex"] = authData["childData"]["UserMaster"]["Sex"];
    }
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["IsTryingToConceive"]
    ) {
      global.userAry["IsTryingToConceive"] =
        authData["childData"]["UserMaster"]["IsTryingToConceive"];
    }
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["EmailAddress"]
    ) {
      global.userAry["EmailAddress"] =
        authData["childData"]["UserMaster"]["EmailAddress"];
    }
    if (
      authData["childData"]["UserMaster"] &&
      authData["childData"]["UserMaster"]["mobileno"]
    ) {
      global.userAry["mobileno"] =
        authData["childData"]["UserMaster"]["mobileno"];
    }
    if (
      authData["childData"]["UserChildList"] &&
      authData["childData"]["UserChildList"].length > 0 &&
      authData["childData"]["UserChildList"][0]["IsExpected"]
    ) {
      global.userAry["IsExpected"] =
        authData["childData"]["UserChildList"][0]["IsExpected"] || 0;
      global.userAry["expectedDob"] =
        authData["childData"]["UserChildList"][0]["DOB"];
    }
}}

console.log("global.userAry =", global.userAry)

if (typeof window !== "undefined") {

window.addEventListener("FC_LOGOUT", () => {
  console.log("📢 MF LOGOUT EVENT RECEIVED IN HOST...");

  Cookies.remove("FC_AUTH", { path: "/", domain: ".firstcry.com" });
  Cookies.remove("ftk");
  Cookies.remove("app_ftk");
  localStorage.removeItem("authData");

  const cookieOptions = {
    domain: ".firstcry.com",
    path: "/",
  };

  [
    "FC_AUTH",
    "_$FC_LoginInfo$_",
    "_$FC_EmlUsr$_",
    "_$FC_UserInfo$_",
    "_login_name_",
    "FC_LGN_PG",
    "FC_AUTH_GUE",
    "_$logindtuser$_",
    "isloged",
    "parentingAuthData",
    "userData",
  ].forEach(cookie => {
    Cookies.remove(cookie, cookieOptions);
  });
  
  Cookies.remove("currentchildSeq", { domain: "parenting.firstcry.com", path: "/", });
  Cookies.remove("feedProfile", { domain: "parenting.firstcry.com", path: "/", });

  Cookies.remove("userData", { path: "/" });
  Cookies.remove("userData", { domain: "parenting.firstcry.com",path: "/",});

  localStorage.removeItem("authData");
  
  // 🔥 clear globals
  global.ftk = "";
  global.accessToken = "";
  global.uID = "";
  global.clientId = "";
  global.userAry = {};
  delete window.__AUTH_DATA__;


  console.log("✅ AFTER LOGOUT global.ftk =>", global.ftk);
  console.log("✅ AFTER LOGOUT __AUTH_DATA__ =>", window.__AUTH_DATA__);

  store.dispatch(logoutUser());

  // setTimeout added to re-render host after logout event
  setTimeout(() => {
    window.location.reload();
  }, 50);
  
});
}

console.log("🌍 Running in BROWSER");
console.log("🚀 global.ftk in client index.js ==>", global.ftk);
console.log("Window __AUTH_DATA__ in client index.js ==>", window.__AUTH_DATA__.authData);



if (typeof window !== 'undefined' && container) {
  root.render(
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App location={window.location.href} />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  );
}